package api

sealed class ClientAppType(val id: Long, val label: String) {
    data object UNKNOWN : ClientAppType(-1L, "UNKNOWN")
    data object RUNTIME : ClientAppType(0L, "RUNTIME")
    data object CONNECTOR : ClientAppType(1L, "CONNECTOR")
    data object UPDATER : ClientAppType(2L, "UPDATER")

    companion object {
        val all by lazy {
            listOf(UNKNOWN, RUNTIME, CONNECTOR, UPDATER)
        }

        operator fun get(id: Long): ClientAppType {
            return all.firstOrNull {
                it.id == id
            } ?: UNKNOWN
        }
    }
}
